<template>
  <div class="company">
    <div class="banner-div">
      <img :src="require(`@/assets/images/${languages}/company/banner.jpg`)" alt="">
    </div>
    <div class="main-box">
      <div class="title">
        {{languagesData['company'].title}}  
      </div>
      <div class="company-main">
        <ul>
          <li v-for="iten in languagesData['company'].companyDets">
            <span>{{iten.label}}</span><span><em v-if="iten.img"><img :src="require('../assets/images/'+iten.img+'')"
                  alt=""></br> </em> <a :href="iten.url" target="_blank">{{iten.url}}</a> {{iten.content}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  export default {
    data() {
      return {
        resDatas: ''
      }
    },
    computed: {
      ...mapState(["languages","languagesData"]) // 在这里引入你需要的state值
    },
    mounted() {
      this.$store.state.highlight = 'company';
    }
  }
</script>

<style scoped>
  .company {
    width: 100%;
    margin: 0 auto;
    
  }

  .company .banner-div img{
    display: block;
    width: 100%;
    margin: 0 auto;
    /* margin-top: 84px; */
padding-top: 84px;
      background: black;
  }

  .company .title {
    font-size: 30px;
    padding: 3%;
    font-weight: 600;
    text-align: center;
  }

  .company-main {
    margin-top: 3%;
  }

  .company-main li {
    display: block;
    padding: 2%;
    font-size: 0;
    box-sizing: border-box;
  }

  .company-main li:nth-of-type(2n+1) {
    background-color: #EBEBEB;
  }

  .company-main li span {
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    vertical-align: middle;
    word-break: break-word;
    box-sizing: border-box;
  }

  .company-main li span:nth-of-type(1) {
    width: 34%;
    text-align: center;
    word-break: break-word;
  }

  .company-main li span:nth-of-type(2) {
    width: 66%;
    color: #818181;
    padding: 0 1%;
  }

  .company-main li span img {
    width: 35%;
    vertical-align: middle;
  }
  .main-box{
    padding: 100px 0 150px;
  }
  @media screen and (max-width: 1000px) {
    .company {
      margin: auto;
    }

    .company-main li {
      padding: 1.5% 0;
    }

    .company-main li span {
      font-size: 16px;
    }

    .company-main li span:nth-of-type(1) {
      padding: 0 1.5%;
    }

    .company-main li span img {
      width: 50%;
      vertical-align: middle;
    }
    .main-box {
        padding: 10% 0 16%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/company.vue